import PropTypes from 'prop-types';
import ProposalFormInner from './components/proposal-form-inner';
import ProposalFormProvider from './context/proposal-form-context';

const ProposalForm = ({
  proposal = {},
  primaryContactId,
  setProposal = () => null,
  closeModal = () => null,
  afterCreate = () => null,
}) => {
  return (
    <ProposalFormProvider>
      <ProposalFormInner
        proposal={proposal}
        primaryContactId={primaryContactId}
        setProposal={setProposal}
        closeModal={closeModal}
        afterCreate={afterCreate}
      />
    </ProposalFormProvider>
  );
};

ProposalForm.propTypes = {
  proposal: PropTypes.object,
  primaryContactId: PropTypes.number,
  closeModal: PropTypes.func,
  setProposal: PropTypes.func,
  afterCreate: PropTypes.func,
};

export default ProposalForm;
